import { render, staticRenderFns } from "./AddPower.vue?vue&type=template&id=58863df6&scoped=true&"
import script from "./AddPower.vue?vue&type=script&lang=js&"
export * from "./AddPower.vue?vue&type=script&lang=js&"
import style0 from "./AddPower.vue?vue&type=style&index=0&id=58863df6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58863df6",
  null
  
)

export default component.exports